import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <Container className="privacy-policy">
      <Row>
        <Col className="text-center">
          <h1 className="privacy-policy-h1-mini">Informacje</h1>
          <h1 className="privacy-policy-h1">Polityka prywatności</h1>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h3 className="privacy-policy-h3">Administrator danych osobowych</h3>
          <p>
            Administratorem Twoich danych osobowych jest dwojka.net Usługi
            informatyczne, ul. Bzowa 3/2, 80-376 Gdańsk, NIP: 8471004220 (dalej:
            „Administrator”). Kontakt w sprawach dotyczących ochrony danych
            osobowych: <strong>kontakt@strefadlaedukacji.pl</strong> lub
            telefonicznie: <strong>+48 691 166 622</strong>.
          </p>

          <h3 className="privacy-policy-h3">Jakie dane przetwarzamy</h3>
          <p>
            Dane osobowe są przetwarzane wyłącznie w zakresie, w jakim zostały
            podane dobrowolnie za pośrednictwem formularza kontaktowego na
            stronie:
          </p>
          <ul>
            <li>imię i nazwisko,</li>
            <li>adres e-mail,</li>
            <li>treść przesłanej wiadomości.</li>
          </ul>
          <p>
            Podczas korzystania z formularza kontaktowego przetwarzane są
            również dane techniczne generowane przez usługę Google reCAPTCHA,
            wykorzystywaną do ochrony formularza przed spamem i nadużyciami.
          </p>

          <h3 className="privacy-policy-h3">
            Cel i podstawa prawna przetwarzania
          </h3>
          <p>
            Dane osobowe przetwarzane są w celu udzielenia odpowiedzi na
            przesłaną wiadomość oraz obsługi zapytania (art. 6 ust. 1 lit. b i f
            RODO — działania podejmowane na żądanie osoby przed zawarciem umowy
            oraz prawnie uzasadniony interes Administratora polegający na
            komunikacji z osobami zainteresowanymi ofertą), a także w celu
            ochrony formularza przed nadużyciami przy użyciu Google reCAPTCHA
            (art. 6 ust. 1 lit. f RODO).
          </p>

          <h3 className="privacy-policy-h3">Odbiorcy danych</h3>
          <p>
            Dane mogą być przekazywane podmiotom wspierającym Administratora w
            utrzymaniu strony internetowej i obsłudze poczty elektronicznej (np.
            dostawcy hostingu) oraz firmie Google LLC w związku z wykorzystaniem
            usługi reCAPTCHA. Dane nie są przekazywane do państw trzecich poza
            mechanizmami zapewnianymi przez tych dostawców w ramach
            standardowych zabezpieczeń.
          </p>

          <h3 className="privacy-policy-h3">Okres przechowywania danych</h3>
          <p>
            Dane przekazane w formularzu kontaktowym przechowywane są przez
            okres niezbędny do udzielenia odpowiedzi oraz do czasu przedawnienia
            ewentualnych roszczeń związanych z korespondencją, nie dłużej jednak
            niż przez okres 6 miesięcy od ostatniego kontaktu.
          </p>

          <h3 className="privacy-policy-h3">Twoje prawa</h3>
          <p>
            W związku z przetwarzaniem danych osobowych przysługuje Ci prawo do:
          </p>
          <ul>
            <li>dostępu do swoich danych oraz otrzymania ich kopii,</li>
            <li>sprostowania (poprawiania) danych,</li>
            <li>usunięcia danych,</li>
            <li>ograniczenia przetwarzania danych,</li>
            <li>wniesienia sprzeciwu wobec przetwarzania danych.</li>
          </ul>
          <p>
            Podanie danych w formularzu kontaktowym jest dobrowolne, ale
            niezbędne do udzielenia odpowiedzi na przesłane zapytanie.
          </p>

          <h3 className="privacy-policy-h3">Pliki cookie</h3>
          <p>
            Szczegółowe informacje na temat wykorzystywanych plików cookie
            znajdziesz w <a href="/polityka-cookies">Polityce cookies</a>.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
